import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

import { LocaleStrings, SupportedLocale } from './models';

const localeEntityAdapter = createEntityAdapter<LocaleStrings, SupportedLocale>(
  {
    selectId: (localeStrings) => localeStrings.locale,
  }
);

const DEFAULT_LOCALE_STRINGS = {};
export const localizationSlice = createSlice({
  name: 'localization',
  initialState: localeEntityAdapter.getInitialState({
    currentLocale: 'en-us' as SupportedLocale, //default is en-us
    loading: true, // at time 0 we don't have any locales loaded, so default to loading
  }),
  reducers: {
    localeLoaded(state, action: PayloadAction<LocaleStrings>) {
      state.loading = false;
      localeEntityAdapter.upsertOne(state, action.payload);
    },
    currentLocaleUpdated(state, action: PayloadAction<SupportedLocale>) {
      state.currentLocale = action.payload;
    },
    //TODO(nibeauli): check if we need to support something like "unloading" a locale for memory reasons.
  },
  selectors: {
    loadedLocales: (s) => Object.keys(s.entities),
    // The type definition of EntityState makes it tricky to deal with 'hollow' objects if the keyspace is typed.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    currentLocale: (s) => s.entities[s.currentLocale] ?? DEFAULT_LOCALE_STRINGS,
    isLoading: (s) => s.loading,
    ...localeEntityAdapter.getSelectors(), //generally not the best option, but it works for now.
  },
});
